/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserTenantDto
 */
export interface UserTenantDto {
    /**
     * 
     * @type {string}
     * @memberof UserTenantDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTenantDto
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTenantDto
     */
    tenantId?: string;
    /**
     * Tenant name for this membership
     * @type {string}
     * @memberof UserTenantDto
     */
    tenantName?: string;
    /**
     * Tenant slug for this membership
     * @type {string}
     * @memberof UserTenantDto
     */
    tenantSlug?: string;
    /**
     * Customer ID for this tenant
     * @type {string}
     * @memberof UserTenantDto
     */
    customerId?: string;
    /**
     * Customer name for this tenant
     * @type {string}
     * @memberof UserTenantDto
     */
    customerName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTenantDto
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserTenantDto
     */
    lastLogin?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserTenantDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserTenantDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof UserTenantDto
     */
    active?: boolean;
}

/**
 * Check if a given object implements the UserTenantDto interface.
 */
export function instanceOfUserTenantDto(value: object): value is UserTenantDto {
    return true;
}

export function UserTenantDtoFromJSON(json: any): UserTenantDto {
    return UserTenantDtoFromJSONTyped(json, false);
}

export function UserTenantDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTenantDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'tenantName': json['tenantName'] == null ? undefined : json['tenantName'],
        'tenantSlug': json['tenantSlug'] == null ? undefined : json['tenantSlug'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'email': json['email'] == null ? undefined : json['email'],
        'lastLogin': json['lastLogin'] == null ? undefined : (new Date(json['lastLogin'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function UserTenantDtoToJSON(json: any): UserTenantDto {
    return UserTenantDtoToJSONTyped(json, false);
}

export function UserTenantDtoToJSONTyped(value?: UserTenantDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'tenantId': value['tenantId'],
        'tenantName': value['tenantName'],
        'tenantSlug': value['tenantSlug'],
        'customerId': value['customerId'],
        'customerName': value['customerName'],
        'email': value['email'],
        'lastLogin': value['lastLogin'] == null ? undefined : ((value['lastLogin']).toISOString()),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'active': value['active'],
    };
}

